import React from 'react';
import { StyledSelect, Wrapper, StyledLabel, StyledError } from './styles';
export const SelectInput = ({ defaultOption = '', errorMessage = '', label = '', id = '', onChangeValue = () => { }, options = [], state = '', value = '', }) => {
    return (React.createElement(Wrapper, null,
        React.createElement(StyledSelect, { id: id, onChange: event => onChangeValue(event.target.value), state: state, value: value },
            defaultOption && React.createElement("option", { key: 0 }, defaultOption),
            options.map((option, key) => (React.createElement("option", { key: key + 1, value: option.value }, option.label)))),
        React.createElement(StyledLabel, { state: state }, label),
        errorMessage && React.createElement(StyledError, null, errorMessage)));
};
